const btnCompleteAction = {
  text: 'Complete Action'
};

export default btnCompleteAction;
